export default "__VITE_ASSET__Ca8ZUTZ3__"